import { IItem } from "../interfaces/Item";
import { BARCODE, PICTURE, VARIABLE_PICTURE, SIMPLE_TEXT, VARIABLE_TEXT, HORIZONTAL_LINE, VERTICAL_LINE } from "./ItemTypes";
import { align } from "./constants";

export const items: IItem[] = [
  {
    itemid: 0,
    id: "simple-text",
    text: "simple_text",// "Tekstas",
    iconName: "header",
    type: SIMPLE_TEXT,
    xInMM: 0,
    yInMM: 0,
    selected: false,
    style: {
      position: "absolute",
      top: "0px",
      left: "0px",
    },
    value: "",
    rotation: 0,
    fontBold: false,
    fontSize: 12,
    fontName: "Arial",
  },
  {
    itemid: 0,
    id: "barcode",
    text:"barcode",// "Barkodas",
    iconName: "barcode",
    type: BARCODE,
    xInMM: 0,
    yInMM: 0,
    selected: false,
    style: {
      position: "absolute",
      top: "0px",
      left: "0px",
    },
    value: "",
    rotation: 0,
  },
  {
    itemid: 0,
    id: "variable-text",
    text:"variable_text",// "Kintamas tekstas",
    iconName: "h",
    type: VARIABLE_TEXT,
    xInMM: 0,
    yInMM: 0,
    selected: false,
    style: {
      position: "absolute",
      top: "0px",
      left: "0px",
    },
    value: "",
    rotation: 0,
    align: align.left,
    fontBold: false,
    fontSize: 12,
    fontName: "Arial",
    name: "ITEM_ID",
    wrap: false,
    defaultText: "",
  },
  {
    itemid: 0,
    id: "picture",
    text:"picture",// "Paveikslėlis",
    iconName: "picture",
    type: PICTURE,
    xInMM: 0,
    yInMM: 0,
    selected: false,
    style: {
      position: "absolute",
      top: "0px",
      left: "0px",
    },
    rotation: 0,
    value: "",
    width: 20,
    height: 20,
    path: "",
    keepRatio: true,
  },
  {
    itemid: 0,
    id: "variable_picture",
    text:"variable_picture",// "Kintamas paveikslėlis",
    iconName: "photo",
    type: VARIABLE_PICTURE,
    xInMM: 0,
    yInMM: 0,
    selected: false,
    style: {
      position: "absolute",
      top: "0px",
      left: "0px",
    },
    rotation: 0,
    value: "",
    width: 20,
    height: 20,
    path: "",
    keepRatio: true,
  },
  {
    itemid: 0,
    id: "horizontal-line",
    text: "line",//"Linija",
    iconName: "arrows alternate horizontal",
    type: HORIZONTAL_LINE,
    xInMM: 0,
    yInMM: 0,
    selected: false,
    style: {
      position: "absolute",
      top: "0px",
      left: "0px",
    },

    yToInMM: 0,
    xToInMM: 20,
    rotation: 0,
    value: "",
    lineWidth: 0.4
  },
  {
    itemid: 0,
    id: "vertical-line",
    text: "vertical_line",//"Vertikali linija",
    iconName: "arrows alternate vertical",
    type: VERTICAL_LINE,
    xInMM: 0,
    yInMM: 0,
    selected: false,
    style: {
      position: "absolute",
      top: "0px",
      left: "0px",
    },

    yToInMM: 20,
    xToInMM: 0,
    rotation: 0,
    value: "",
    lineWidth: 0.4
  },
];
